module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAQAAAC1+jfqAAAAqElEQVR4AcXBoWoCYQAA4E+84+4UVjZW1WDZxGY02ewLgkEwjIXTZlo4rDJW9gyCSW5Rn8S3Gb8aRIwDv889POmquCFRF4x9qUtcSRVyVPwY+VBIXUgtlVp49qutobSUOssUtpqCgbUETVuFzFHPwdDJp4WToYOeo9jMTgc1G31Bx85M7Cwyt/fqRekRXXtzkQuR3NTEt+BdLnKlKrbyJohV3dTy4N/9AVLWGgmnOMeJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/favicons/favicon-16x16.png
// module id = 94
// module chunks = 0